import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f1d824a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pricing-margin-search"
};
const _hoisted_2 = {
  class: "search-wrapper"
};
const _hoisted_3 = {
  class: "export-wrapper"
};
const _hoisted_4 = {
  class: "pricing-and-margin-data-content"
};
const _hoisted_5 = {
  class: "pricing-and-margin-data-content-middle"
};
const _hoisted_6 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pricing_and_margin_top_section = _resolveComponent("pricing-and-margin-top-section");
  const _component_app_input = _resolveComponent("app-input");
  const _component_pricing_and_margin_export_drop_down = _resolveComponent("pricing-and-margin-export-drop-down");
  const _component_error_occured = _resolveComponent("error-occured");
  const _component_pricing_and_margin_data_content = _resolveComponent("pricing-and-margin-data-content");
  const _component_app_pagination = _resolveComponent("app-pagination");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    contentPadding: "0",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.openModal = $event),
    showPagination: true
  }, {
    "topbar-contents": _withCtx(() => [_createVNode(_component_pricing_and_margin_top_section)]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_app_input, {
      class: "pricing-margin-search-input",
      modelValue: $data.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
      placeholder: "Filter items...",
      debounce: "300",
      v2: "",
      version: "search",
      onChange: $options.searchItem
    }, null, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_pricing_and_margin_export_drop_down, {
      isDownloadRunning: $data.isDownloadRunning,
      onDownloadContentCsv: $options.handleSelectionDownloadTypeCSV
    }, null, 8, ["isDownloadRunning", "onDownloadContentCsv"])])])]),
    pagination: _withCtx(() => [_createVNode(_component_app_pagination, {
      page: $data.page,
      "onUpdate:page": [_cache[1] || (_cache[1] = $event => $data.page = $event), $options.changePage],
      perPage: $data.perPage,
      "onUpdate:perPage": [_cache[2] || (_cache[2] = $event => $data.perPage = $event), $options.changeElements],
      total: _ctx.total_rows
    }, null, 8, ["page", "perPage", "total", "onUpdate:page", "onUpdate:perPage"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_error_occured, {
      onRetry: $options.refreshPricingAndMarginContent
    }, null, 8, ["onRetry"])])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["pricing-and-margin-data-content", {
        blur: $data.dataLoading
      }])
    }, [$options.pmDataInitialized && !$data.errorOccured ? (_openBlock(), _createBlock(_component_pricing_and_margin_data_content, {
      key: 0,
      items: $options.dfFiltered,
      selected: $data.selected,
      sortField: $data.sortField,
      sortDirection: $data.sortDirection,
      settings: $data.currentSettings,
      accountProvider: _ctx.accountProvider,
      dataLoading: $options.dataLoadingDf,
      onSort: $options.onSort
    }, null, 8, ["items", "selected", "sortField", "sortDirection", "settings", "accountProvider", "dataLoading", "onSort"])) : _createCommentVNode("", true)], 2)])])]),
    _: 1
  }, 8, ["modelValue"]);
}